<template>
    <div class="modal fade" id="commercial_invoice_modal" tabindex="-1" role="dialog" aria-labelledby="commercial_invoice_modal_label" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> {{ $helper.trans('Completing_commercial_invoice') }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row d-flex justify-content-center commercialInvoiceModal">
                        <div class="col-12 mt-4 input-grid">
                            <label for="op-7" class="custom-checkbox-wrap" @click="$forceUpdate();checkSameInvoiceAddress();">
                                {{ $helper.trans('Buyer_and_shipping_addresses_match') }}
                                <input type="checkbox" id="op-7" v-model="$store.state.commercialInvoiceModal.sameInvoiceAddress" :value="1">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="col-12 input-grid mt-3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.companyOrSender" :placeholder="'* '+$helper.trans('Company_or_firstname_lastname')" class="input-big w-100 commercialInvoiceModal_differentAddress_companyOrSender_input" />
                        </div>
                        <div class="col-12 input-grid mt-3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.contactPerson" :placeholder="'* '+$helper.trans('Contact_person')" class="input-big w-100 commercialInvoiceModal_differentAddress_contactPerson_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 phone" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.phone" :placeholder="'* '+$helper.trans('Phone_number')" class="input-big w-100 commercialInvoiceModal_differentAddress_phone_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 email" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.email" :placeholder="'* '+$helper.trans('Contact_email')" class="input-big w-100 commercialInvoiceModal_differentAddress_email_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 city" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.city" :placeholder="'* '+$helper.trans('City')" class="input-big w-100 commercialInvoiceModal_differentAddress_city_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 address1" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.address1" :placeholder="'* '+$helper.trans('Address')+' 1'" class="input-big w-100 commercialInvoiceModal_differentAddress_address1_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 address2" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.address2" :placeholder="$helper.trans('Address')+' 2'" class="input-big w-100 commercialInvoiceModal_differentAddress_address2_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 address3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.address3" :placeholder="$helper.trans('Address')+' 3'" class="input-big w-100 commercialInvoiceModal_differentAddress_address3_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 countryCode" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <select2-component
                                :values="countries"
                                :placeholder="'* ' + $helper.trans('Country')"
                                :noLang="true"
                                :notKeyed="true"
                                classes="input-big commercialInvoiceModal_differentAddress_countryCode_input"
                                v-model="$store.state.commercialInvoiceModal.differentAddress.countryCode"
                            ></select2-component>    
                        </div>
                        <div class="col-12 input-grid mt-3 postCode" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <input type="text" v-model="$store.state.commercialInvoiceModal.differentAddress.postCode" :placeholder="'* '+$helper.trans('Zip_code')" class="input-big w-100 commercialInvoiceModal_differentAddress_postCode_input" />
                        </div>
                        <div class="col-12 input-grid mt-3 stateOrProvince" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress && $store.state.commercialInvoiceModal.differentAddress.countryCode && $store.state.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'us'">
                            <select2-component
                                :values="$store.state.$siteSettings['State_list']"
                                :placeholder="'* '+$helper.trans('State')"
                                classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                v-model="$store.state.commercialInvoiceModal.differentAddress.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="col-12 input-grid mt-3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress && $store.state.commercialInvoiceModal.differentAddress.countryCode && $store.state.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'ca'">
                            <select2-component
                            :values="$store.state.$siteSettings['Province_list']"
                                :placeholder="'* '+$helper.trans('Province')"
                                classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                v-model="$store.state.commercialInvoiceModal.differentAddress.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="col-12 input-grid mt-3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress && $store.state.commercialInvoiceModal.differentAddress.countryCode && $store.state.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'ie'">
                            <select2-component
                                :values="$store.state.$siteSettings['Counties_list']"
                                :placeholder="'* '+$helper.trans('County')"
                                classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                v-model="$store.state.commercialInvoiceModal.differentAddress.stateOrProvince"
                            ></select2-component>
                        </div>
                        <div class="col-12 input-grid mt-3 stateOrProvince" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress && $store.state.commercialInvoiceModal.differentAddress.countryCode && $store.state.commercialInvoiceModal.differentAddress.countryCode.toLowerCase() === 'au'">
                            <select2-component
                                :values="$store.state.$siteSettings['AU_state_list']"
                                :placeholder="'* '+$helper.trans('State')"
                                classes="input-big commercialInvoiceModal_differentAddress_stateOrProvince_input"
                                v-model="$store.state.commercialInvoiceModal.differentAddress.stateOrProvince"
                            />
                        </div>
                        <div class="col-12 input-grid mt-3" v-show="!$store.state.commercialInvoiceModal.sameInvoiceAddress">
                            <div class="border-solid"></div>
                        </div>

                        <div class="col-12 input-grid">
                            <div class="mt-3 position-relative">
                                <select2-component
                                    :values="deliveryConditionsValues"
                                    :placeholder="$helper.trans('Delivery_conditions')+' *'"
                                    :noLang="true"
                                    classes="vue-select2 commercialInvoiceModal_commercialInvoiceCondition_input"
                                    v-model="$store.state.commercialInvoiceModal.commercialInvoiceCondition"
                                ></select2-component>
                                <i class="fa fa-question-circle info-question-circle position-absolute" style="top: 0; right: -15px;">
                                    <div class="custom-popover-wrapper">
                                        <div class="custom-popover alert alert-secondary" v-html="exportInfoCloud"></div>
                                    </div>
                                </i>
                            </div>
                            <div class="mt-3">
                                <select2-component
                                    :values="$store.state.$siteSettings['Export_reasons_admin'].split(',')"
                                    :placeholder="$helper.trans('Reason_for_export')+' *'"
                                    :noLang="true"
                                    classes="vue-select2 commercialInvoiceModal_commercialInvoiceExportReason_input"
                                    v-model="$store.state.commercialInvoiceModal.commercialInvoiceExportReason"
                                ></select2-component>
                            </div>
                            <div class="mt-3">
                                <select2-component
                                    :values="currencies"
                                    :placeholder="$helper.trans('Currency')+' *'"
                                    :noLang="true"
                                    classes="vue-select2 commercialInvoiceModal_commercialInvoiceCurrency_input"
                                    v-model="$store.state.commercialInvoiceModal.commercialInvoiceCurrency"
                                ></select2-component>
                            </div>
                            <div class="mt-3">
                                <input type="text" v-model="$store.state.commercialInvoiceModal.receiverTaxNumber" :placeholder="$helper.trans('Recipient_taxpayer_number')" class="input-big w-100 commercialInvoiceModal_receiverTaxNumber_input" />
                            </div>

                            <div class="border-solid"></div>
                        </div>
                        <div class="col-12 input-grid declaration">
                            <span class="title-text">
                                {{ $helper.trans('Declaration_info') }} *
                            </span>
                            <textarea class="w-100 commercialInvoiceModal_declaration_input" v-model="$store.state.commercialInvoiceModal.declaration" cols="10" rows="8"></textarea>
                        </div>
                        <div class="col-12 input-grid">
                            <div class="mt-4">
                                <span class="title-text">
                                    {{ $helper.trans('Additional_comments') }}
                                </span>
                                <textarea class="w-100 commercialInvoiceModal_description_input" v-model="$store.state.commercialInvoiceModal.description" cols="10" rows="3"></textarea>
                            </div>

                            <div class="border-solid"></div>

                            <span class="warning">
                                {{ $helper.trans('Information_about_shipped_goods') }}
                            </span>
                        </div>
                        <div class="col-12 input-grid products" v-for="(product, productIndex) in $store.state.commercialInvoiceModal.products" :key="productIndex">
                            <div :class="`mt-4 description${productIndex}`">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="title-text">                                        
                                        {{ $helper.trans('Item_description') }} *
                                    </span>
                                    <i v-show="productIndex !== 0" @click="removeProduct(productIndex);" class="fa fa-times" style="color: red; cursor: pointer;"></i>
                                </div>
                                <textarea 
                                    v-model="$store.state.commercialInvoiceModal.products[productIndex].description" 
                                    class="w-100" 
                                    :class="`commercialInvoiceModal_products_${productIndex}_description_input`" 
                                    cols="10" 
                                    rows="3"
                                ></textarea>
                            </div>
                            <div :class="`mt-3 tariffCode${productIndex}`">
                                <input type="text" 
                                    v-model="$store.state.commercialInvoiceModal.products[productIndex].tariffCode" 
                                    :placeholder="$helper.trans('Tariff_code') + ($store.state.to.country === 'gb' && $store.state.selectedShippingOption.serviceCode === '11' ? ' *' : '')" 
                                    class="input-big w-100"
                                    :class="`commercialInvoiceModal_products_${productIndex}_tariffCode_input`" 
                                />
                                <i class="fa fa-question-circle info-question-circle position-absolute">
                                    <div class="custom-popover-wrapper">
                                        <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Tariff_code_info')"></div>
                                    </div>
                                </i>
                                <span 
                                    class="warning d-block"
                                    style="font-size: 13px;"
                                    v-if="$store.state.to.country === 'gb' && $store.state.selectedShippingOption.serviceCode === '11'" v-html="$helper.trans('Hs_code')"></span>
                            </div>
                            <div :class="`mt-3 position-relative countryOfOrigin${productIndex}`">               
                                <select2-component
                                    :values="countries"
                                    :placeholder="$helper.trans('Origin_country')+' *'"
                                    :noLang="true"
                                    :notKeyed="true"
                                    :classes="`commercialInvoiceModal_products_${productIndex}_countryOfOrigin_input`"
                                    dropDownClass="select2_customization"
                                    dropDownParent="#commercial_invoice_modal .modal-body"
                                    v-model="$store.state.commercialInvoiceModal.products[productIndex].countryOfOrigin"
                                ></select2-component>    
                                <i class="fa fa-question-circle info-question-circle position-absolute" style="top: 0; right: -15px;">
                                    <div class="custom-popover-wrapper">
                                        <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Origin_country_info')"></div>
                                    </div>
                                </i>                         
                            </div>
                            <div :class="`mt-3 count${productIndex}`">
                                <input type="text" 
                                    v-model="$store.state.commercialInvoiceModal.products[productIndex].count" 
                                    :placeholder="$helper.trans('Number_of_units')+' *'" 
                                    class="input-big w-100" 
                                    :class="`commercialInvoiceModal_products_${productIndex}_count_input`" 
                                />
                            </div>
                            <div :class="`mt-3 unitPrice${productIndex}`">
                                <input type="text" 
                                    v-model="$store.state.commercialInvoiceModal.products[productIndex].unitPrice" 
                                    :placeholder="$helper.trans('Unit_price')+' *'" 
                                    class="input-big w-100" 
                                    :class="`commercialInvoiceModal_products_${productIndex}_unitPrice_input`" 
                                />
                            </div>
                        </div>
                        <div class="col-12 input-grid">
                            <div class="add-another-product text-center mt-4" @click="addProduct();">
                                <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                <p>{{ $helper.trans('Add_another_product') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer-custom">
                    <div class="row d-flex justify-content-center">
                        <div class="col-12 input-grid">
                            <button type="button" @click="saveModal();" class="btn btn-primary">{{ $helper.trans('Submit') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function() {
        return {
            countries: {},
        };
    },
    created: function() {
        let vueThis = this;
        
        vueThis.countries = {};
        $.each(vueThis.$store.state.countriesList, function(index, element) {         
            vueThis.countries[index] = {
                'key': element.country_code.toLowerCase(),
                'text': element.title,
            };
        }); 

        vueThis.$nextTick(function(){
            setTimeout(function() {
                $('#commercial_invoice_modal .vue-select2').select2({width: '100%'});

                $('#commercial_invoice_modal #commercial_invoice_condition').val(vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCondition).trigger('change').on('change', function(){
                    vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCondition = $(this).val();
                });
                $('#commercial_invoice_modal #commercial_invoice_export_reason').val(vueThis.$store.state.commercialInvoiceModal.commercialInvoiceExportReason).trigger('change').on('change', function(){
                    vueThis.$store.state.commercialInvoiceModal.commercialInvoiceExportReason = $(this).val();
                });
                $('#commercial_invoice_modal #commercial_invoice_currency').val(vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCurrency).trigger('change').on('change', function(){
                    vueThis.$store.state.commercialInvoiceModal.commercialInvoiceCurrency = $(this).val();
                });
            }, 250);

        });

        vueThis.$forceUpdate();
    },
    methods: {
        checkSameInvoiceAddress: function() {   
            $('.commercialInvoiceModal_differentAddress_countryCode_input').prop('disabled', true);          
            this.$store.state.commercialInvoiceModal.differentAddress.countryCode = this.$store.state.to.country;            
        },
        addProduct: function() {
            this.$store.state.commercialInvoiceModal.products.push({
                description: '',
                tariffCode: '',
                countryOfOrigin: '',
                count: '',
                unitPrice: '',
            });
        },
        removeProduct: function(index) {
            this.$store.state.commercialInvoiceModal.products.splice(index, 1);
        },
        saveModal: async function() {
            let valid = await this.$helper.validate(['commercialInvoiceModal'], {
                to: this.$store.state.to,
                selectedShippingOption: this.$store.state.selectedShippingOption,
                commercialInvoiceModal: this.$store.state.commercialInvoiceModal,
                uploadedFiles: this.$store.state.uploadedFiles,
                otherDeliveryInformation: {
                    isDocuments: this.$store.state.otherDeliveryInformation.isDocuments,
                    commercialInvoiceType: this.$store.state.otherDeliveryInformation.commercialInvoiceType
                }
            });

            if(valid){
                $('#commercial_invoice_modal').modal('hide');
            }
        },
    },
    computed:{
        deliveryConditionsValues() {
            if (this.isImport) {
                return this.$store.state.$siteSettings['Delivery_conditions_import'].split(',');
            }

            if (this.$store.state.$siteSettings['Logged_in']) {
                return this.$store.state.$siteSettings['Delivery_conditions_admin'].split(',');
            }

            return this.$store.state.$siteSettings['Delivery_conditions_offline_admin'].split(',');
        },
        exportInfoCloud() {
            if (this.isImport) {
                return this.$helper.trans('Delivery_conditions_info_import');
            }     

            if (this.$store.state.$siteSettings['Logged_in'] && this.$store.state.$siteSettings['customer_payment_type'] === 'all') {
                return this.$helper.trans('Delivery_conditions_info_logged_in_all');
            }

            return this.$helper.trans('Delivery_conditions_info_logged_in');
        },
        isImport() {
            return this.$store.state.to.country === 'lt';
        },
        currencies() {
            let options = {};
            let splitCurrencies = this.$store.state.$siteSettings['Commercial_invoice_currencies'].split(',');
            $.each(splitCurrencies, function(index, element) {
                options[element.trim()] = element.trim();
            });

            return options;
        },
    }
}
</script>
